<template>
  <span :class="{light}">
    <slot></slot>
  </span>
</template>

<script>
  export default {
    props: {
      /**
       * Display light color text
       */
      light: Boolean,
      default: false
    }
  }
</script>

<style lang="scss" scoped>
  span {
    color: color(grays, extra-light);
    font-size: rem(12);
    font-style: italic;

    &.light {
      color: #ffffff;
    }
  }
</style>



// WEBPACK FOOTER //
// SmallText.vue?d217d68c